export default "__VITE_ASSET__DgRKYUrG__"